const user = {
  auth: '',
  user: {},
  isBusiness: function () {
    return !!this.user.account;
  },
  isCustomPlan13: function () {
    return this.user.plan === 13;
  },
  isTrafficPlanLifetime: function () {
    return this.user.additionaltrafficlifetime;
  },
  canBuyTraffic: function () {
    return !this.isBusiness() && !this.isCustomPlan13() && !(this.isTrafficPlanLifetime() && this.user.additionaltraffic < 10);
  },
  isPremium: function() {
    return this.user.premium;
  },
  isPremiumPlus: function() {
    return [3, 9, 10, 13, 15, 16, 17, 1001].indexOf(this.user.plan) !== -1;
  },
  isEFH: function() {
    return this.user.efh;
  },
  isFree: function() {
    return this.user.plan === 0;
  },
  getRewindTime: function() {
    return this.user.trashrevretentiondays;

    if (this.isBusiness() || this.isPremiumPlus()) {
      return 180;
    }

    if (this.isFree()) {
      return 30;
    }

    return this.isPremiumPlus() ? 180 : 90;
  },
  isCollaborationEnabled: function() {
    return (typeof this.user.collaboration !== 'undefined' && this.user.collaboration);
  },
  hasCrypto: function () {
    return this.cryptoSettings();
  },
  cryptoSettings: function () {
    var canCryptoSettings;

    canCryptoSettings = this.user.cryptosetup || (new Date(this.user.cryptoexpires) > new Date());
    if (this.isBusiness() && !this.user.account.permissions.crypto_access) {
      canCryptoSettings = false;
    }

    return canCryptoSettings;
  },
};

export default user;